/**
 * i18n strings for the Underlag public form + client sign page.
 * Languages: NO (default), EN, RO, PL
 */
export const UNDERLAG_I18N = {
  no: {
    brand: "Doserne Stillas AS",
    subtitle: "Arbeidsordre og utførelsesbeskrivelse",
    formTitle: "Underlag",
    lang: "Språk",
    date: "Dato",
    address: "Adresse / Prosjekt",
    addressPh: "Gateadresse / prosjektnavn",
    customer: "Kunde",
    customerPh: "Kundens navn / firma",
    customerEmail: "Kundens e-post",
    customerEmailHint: "Kunden får kopi av signert PDF på denne adressen",
    workDesc: "Beskrivelse av arbeid",
    workDescPh: "Kort forklaring på det som ble utført",
    workers: "Arbeidere",
    addWorker: "+ Legg til arbeider",
    removeWorker: "Fjern",
    name: "Navn",
    job: "Jobb",
    description: "Beskrivelse",
    from: "Fra",
    to: "Til",
    timetype: "Type tid",
    sameAsAbove: "Samme som over",
    minusLunch: "-30 min lunsj",
    toll: "Bomkryssinger (fra/til Grua lager)",
    parking: "Parkering",
    materialsUsedQuestion: "Har du brukt materialer? (nett / plast)",
    materialsUsedYes: "Ja",
    materialsUsedNo: "Nei",
    materialsTitle: "Materialer brukt",
    materialsNetRolls: "Nett — antall ruller",
    materialsNetTies: "Nett fasetter — antall poser",
    materialsPlastRolls: "Plast — antall ruller",
    materialsPlastTies: "Plast elastikk — antall poser",
    materialsNetRollsPh: "f.eks. 5",
    materialsNetTiesPh: "f.eks. 20",
    materialsPlastRollsPh: "f.eks. 3",
    materialsPlastTiesPh: "f.eks. 20",
    attachments: "Vedlegg (bilder, dokumenter)",
    uploadHint: "Trykk for å laste opp eller dra filer hit",
    importProgress: "Importer bilder fra daglig fremdrift",
    importProgressTitle: "Bilder fra daglig fremdrift",
    noProgressPhotos: "Ingen fremdriftsbilder for dette prosjektet ennå",
    addSelected: "Legg til valgte",
    selectProjectFirst: "Velg et prosjekt først for å importere bilder",
    workerEmail: "Din e-post (arbeider)",
    workerEmailHint: "Obligatorisk — du får kopi av underlagen",
    ccEmail1: "E-post kopi 1",
    ccEmail2: "E-post kopi 2",
    save: "Lagre og generer signeringslink",
    saving: "Lagrer...",
    saveHint: "Du får to lenker: én for å fortsette redigering, én til å sende kunden for signering.",
    editLink: "Fortsett redigering",
    signLink: "Kundens signeringslink",
    startNew: "Start ny underlag",
    project: "Velg prosjekt",
    projectHint: "Velg fra listen — Adresse, Kunde og Kundens e-post fylles ut automatisk",
    projectNone: "— Fyll ut manuelt —",
    copyLink: "Kopier lenke",
    copied: "Kopiert!",
    number: "Nr.",
    hoursColShort: "Timer (N / OT)",
    normalHours: "Normal timer",
    overtimeHours: "Overtid",
    totalNormal: "Totalt normal timer",
    totalOvertime: "Totalt overtid",
    // Sign page
    signTitle: "Bekreft underlag og signer",
    signSubtitle: "Vennligst gjennomgå detaljene nedenfor og signer for å bekrefte.",
    customerConf: "Kundens bekreftelse",
    yourEmail: "Din e-post",
    firstName: "Fornavn",
    lastName: "Etternavn",
    signature: "Signatur (tegn med finger eller mus)",
    clear: "Slett signatur",
    notPresent: "Kunde ikke tilstede for signering",
    submitSignature: "Bekreft og send",
    signSuccessTitle: "Takk!",
    signSuccessText: "Underlagen er signert og en kopi er sendt på e-post.",
    signedBy: "Signert av",
    alreadySigned: "Denne underlagen er allerede signert.",
    invalidLink: "Denne lenken er ugyldig eller utløpt.",
    required: "Obligatorisk",
    workDescReq: "Beskrivelse av arbeid",
  },
  en: {
    brand: "Doserne Stillas AS",
    subtitle: "Work order and execution description",
    formTitle: "Worksheet",
    lang: "Language",
    date: "Date",
    address: "Address / Project",
    addressPh: "Street address / project name",
    customer: "Customer",
    customerPh: "Customer name / company",
    customerEmail: "Customer email",
    customerEmailHint: "The customer will receive a copy of the signed PDF at this address",
    workDesc: "Work description",
    workDescPh: "Brief explanation of what was done",
    workers: "Workers",
    addWorker: "+ Add worker",
    removeWorker: "Remove",
    name: "Name",
    job: "Job",
    description: "Description",
    from: "From",
    to: "To",
    timetype: "Timetype",
    sameAsAbove: "Same as above",
    minusLunch: "-30 min lunch",
    toll: "Toll crossings (from/to warehouse Grua)",
    parking: "Parking",
    materialsUsedQuestion: "Did you use materials? (net / plastic)",
    materialsUsedYes: "Yes",
    materialsUsedNo: "No",
    materialsTitle: "Materials used",
    materialsNetRolls: "Net — number of rolls",
    materialsNetTies: "Net ties — number of bags",
    materialsPlastRolls: "Plastic — number of rolls",
    materialsPlastTies: "Plastic elastic ties — number of bags",
    materialsNetRollsPh: "e.g. 5",
    materialsNetTiesPh: "e.g. 20",
    materialsPlastRollsPh: "e.g. 3",
    materialsPlastTiesPh: "e.g. 20",
    attachments: "Attachments (images, documents)",
    uploadHint: "Tap to upload or drag files here",
    importProgress: "Import photos from daily progress",
    importProgressTitle: "Photos from daily progress",
    noProgressPhotos: "No progress photos for this project yet",
    addSelected: "Add selected",
    selectProjectFirst: "Pick a project first to import photos",
    workerEmail: "Your email (worker)",
    workerEmailHint: "Required — you will receive a copy",
    ccEmail1: "E-mail copy 1",
    ccEmail2: "E-mail copy 2",
    save: "Save & generate signature link",
    saving: "Saving...",
    saveHint: "You will get two links: one to continue editing, one to send to the customer for signature.",
    editLink: "Continue editing",
    signLink: "Customer signature link",
    startNew: "Start new worksheet",
    project: "Select project",
    projectHint: "Pick from the list — Address, Customer and Customer email are filled in automatically",
    projectNone: "— Fill in manually —",
    copyLink: "Copy link",
    copied: "Copied!",
    number: "No.",
    hoursColShort: "Hours (N / OT)",
    normalHours: "Normal hours",
    overtimeHours: "Overtime",
    totalNormal: "Total normal hours",
    totalOvertime: "Total overtime",
    signTitle: "Confirm worksheet and sign",
    signSubtitle: "Please review the details below and sign to confirm.",
    customerConf: "Customer confirmation",
    yourEmail: "Your email",
    firstName: "First name",
    lastName: "Last name",
    signature: "Signature (draw with finger or mouse)",
    clear: "Clear signature",
    notPresent: "Customer not present for signature",
    submitSignature: "Confirm and submit",
    signSuccessTitle: "Thank you!",
    signSuccessText: "The worksheet has been signed and a copy has been sent by email.",
    signedBy: "Signed by",
    alreadySigned: "This worksheet has already been signed.",
    invalidLink: "This link is invalid or expired.",
    required: "Required",
    workDescReq: "Work description",
  },
  ro: {
    brand: "Doserne Stillas AS",
    subtitle: "Comandă de lucru și descriere execuție",
    formTitle: "Fișă de lucru",
    lang: "Limba",
    date: "Data",
    address: "Adresă / Proiect",
    addressPh: "Adresă / numele proiectului",
    customer: "Client",
    customerPh: "Numele clientului / firma",
    customerEmail: "Email client",
    customerEmailHint: "Clientul primește o copie a PDF-ului semnat pe această adresă",
    workDesc: "Descrierea lucrării",
    workDescPh: "Explicație scurtă a ceea ce s-a executat",
    workers: "Muncitori",
    addWorker: "+ Adaugă muncitor",
    removeWorker: "Șterge",
    name: "Nume",
    job: "Activitate",
    description: "Descriere",
    from: "De la",
    to: "Până la",
    timetype: "Tip oră",
    sameAsAbove: "La fel ca mai sus",
    minusLunch: "-30 min pauză",
    toll: "Taxe drum (de la / la depozit Grua)",
    parking: "Parcare",
    materialsUsedQuestion: "Ai folosit materiale? (plasă / plastic)",
    materialsUsedYes: "Da",
    materialsUsedNo: "Nu",
    materialsTitle: "Materiale folosite",
    materialsNetRolls: "Plasă — număr role",
    materialsNetTies: "Fasete plasă — număr pungi",
    materialsPlastRolls: "Plastic — număr role",
    materialsPlastTies: "Elastice plastic — număr pungi",
    materialsNetRollsPh: "ex. 5",
    materialsNetTiesPh: "ex. 20",
    materialsPlastRollsPh: "ex. 3",
    materialsPlastTiesPh: "ex. 20",
    attachments: "Atașamente (poze, documente)",
    uploadHint: "Apasă pentru a încărca sau trage fișierele aici",
    importProgress: "Importă poze din progresul zilnic",
    importProgressTitle: "Poze din progresul zilnic",
    noProgressPhotos: "Încă nu există poze de progres pentru acest proiect",
    addSelected: "Adaugă selectate",
    selectProjectFirst: "Alege întâi un proiect ca să imporți poze",
    workerEmail: "E-mailul tău (muncitor)",
    workerEmailHint: "Obligatoriu — primești o copie a fișei",
    ccEmail1: "E-mail copie 1",
    ccEmail2: "E-mail copie 2",
    save: "Salvează și generează link semnătură",
    saving: "Salvez...",
    saveHint: "Vei primi două link-uri: unul pentru continuarea editării, altul pentru a-l trimite clientului spre semnare.",
    editLink: "Continuă editarea",
    signLink: "Link semnătură client",
    startNew: "Începe fișă nouă",
    project: "Alege proiect",
    projectHint: "Alege din listă — Adresa, Clientul și Email-ul clientului se completează automat",
    projectNone: "— Completează manual —",
    copyLink: "Copiază link",
    copied: "Copiat!",
    number: "Nr.",
    hoursColShort: "Ore (N / OT)",
    normalHours: "Ore normale",
    overtimeHours: "Ore supl.",
    totalNormal: "Total ore normale",
    totalOvertime: "Total ore suplimentare",
    signTitle: "Confirmă fișa și semnează",
    signSubtitle: "Verifică detaliile de mai jos și semnează pentru confirmare.",
    customerConf: "Confirmare client",
    yourEmail: "E-mailul tău",
    firstName: "Prenume",
    lastName: "Nume",
    signature: "Semnătură (desenează cu degetul sau mouse-ul)",
    clear: "Șterge semnătura",
    notPresent: "Clientul nu este prezent pentru semnare",
    submitSignature: "Confirmă și trimite",
    signSuccessTitle: "Mulțumim!",
    signSuccessText: "Fișa a fost semnată și o copie a fost trimisă prin e-mail.",
    signedBy: "Semnat de",
    alreadySigned: "Această fișă a fost deja semnată.",
    invalidLink: "Acest link este invalid sau expirat.",
    required: "Obligatoriu",
    workDescReq: "Descrierea lucrării",
  },
  pl: {
    brand: "Doserne Stillas AS",
    subtitle: "Zlecenie pracy i opis wykonania",
    formTitle: "Karta pracy",
    lang: "Język",
    date: "Data",
    address: "Adres / Projekt",
    addressPh: "Adres / nazwa projektu",
    customer: "Klient",
    customerPh: "Nazwa klienta / firma",
    customerEmail: "E-mail klienta",
    customerEmailHint: "Klient otrzyma kopię podpisanego PDF na ten adres",
    workDesc: "Opis pracy",
    workDescPh: "Krótkie wyjaśnienie wykonanej pracy",
    workers: "Pracownicy",
    addWorker: "+ Dodaj pracownika",
    removeWorker: "Usuń",
    name: "Imię",
    job: "Praca",
    description: "Opis",
    from: "Od",
    to: "Do",
    timetype: "Typ czasu",
    sameAsAbove: "Tak samo jak wyżej",
    minusLunch: "-30 min lunch",
    toll: "Opłaty drogowe (do/z magazynu Grua)",
    parking: "Parking",
    materialsUsedQuestion: "Czy użyto materiałów? (siatka / plastik)",
    materialsUsedYes: "Tak",
    materialsUsedNo: "Nie",
    materialsTitle: "Użyte materiały",
    materialsNetRolls: "Siatka — liczba rolek",
    materialsNetTies: "Paski siatki — liczba woreczków",
    materialsPlastRolls: "Plastik — liczba rolek",
    materialsPlastTies: "Elastyczne plastikowe — liczba woreczków",
    materialsNetRollsPh: "np. 5",
    materialsNetTiesPh: "np. 20",
    materialsPlastRollsPh: "np. 3",
    materialsPlastTiesPh: "np. 20",
    attachments: "Załączniki (zdjęcia, dokumenty)",
    uploadHint: "Kliknij, aby przesłać lub przeciągnij pliki tutaj",
    importProgress: "Importuj zdjęcia z dziennego postępu",
    importProgressTitle: "Zdjęcia z dziennego postępu",
    noProgressPhotos: "Brak zdjęć postępu dla tego projektu",
    addSelected: "Dodaj wybrane",
    selectProjectFirst: "Najpierw wybierz projekt, aby zaimportować zdjęcia",
    workerEmail: "Twój e-mail (pracownik)",
    workerEmailHint: "Wymagane — otrzymasz kopię",
    ccEmail1: "E-mail kopia 1",
    ccEmail2: "E-mail kopia 2",
    save: "Zapisz i wygeneruj link do podpisu",
    saving: "Zapisywanie...",
    saveHint: "Otrzymasz dwa linki: jeden do dalszej edycji, drugi do wysłania klientowi do podpisu.",
    editLink: "Kontynuuj edycję",
    signLink: "Link do podpisu klienta",
    startNew: "Zacznij nową kartę",
    project: "Wybierz projekt",
    projectHint: "Wybierz z listy — Adres, Klient i E-mail klienta zostaną wypełnione automatycznie",
    projectNone: "— Wypełnij ręcznie —",
    copyLink: "Kopiuj link",
    copied: "Skopiowano!",
    number: "Nr",
    hoursColShort: "Godziny (N / OT)",
    normalHours: "Godziny normalne",
    overtimeHours: "Nadgodziny",
    totalNormal: "Suma godzin normalnych",
    totalOvertime: "Suma nadgodzin",
    signTitle: "Potwierdź kartę i podpisz",
    signSubtitle: "Sprawdź szczegóły i podpisz, aby potwierdzić.",
    customerConf: "Potwierdzenie klienta",
    yourEmail: "Twój e-mail",
    firstName: "Imię",
    lastName: "Nazwisko",
    signature: "Podpis (rysuj palcem lub myszką)",
    clear: "Wyczyść podpis",
    notPresent: "Klient nieobecny przy podpisaniu",
    submitSignature: "Potwierdź i wyślij",
    signSuccessTitle: "Dziękujemy!",
    signSuccessText: "Karta została podpisana, kopia została wysłana e-mailem.",
    signedBy: "Podpisane przez",
    alreadySigned: "Ta karta już została podpisana.",
    invalidLink: "Ten link jest nieprawidłowy lub wygasł.",
    required: "Wymagane",
    workDescReq: "Opis pracy",
  },
};

export const TIMETYPES = ["Normal time", "Overtime", "Overtid bare tillegget", "Lunch"];
export const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
export const MINUTES = ["00", "15", "30", "45"];
